import{jsx as o}from"react/jsx-runtime";import{Container as i}from"./Divider.styles.js";const t=({variant:r="horizontal"})=>o(i,{variant:r,className:"divider-root"});export{t as Divider};
